var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-select-field"},[_c('label',{staticClass:"app-select-field-label"},[_vm._v(_vm._s(_vm.label))]),_c('v-select',{attrs:{"items":_vm.items,"menu-props":"auto","hide-details":"","label":"Select","single-line":""},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }